import {
  fetchAndActivate,
  getAll,
  getRemoteConfig,
} from "firebase/remote-config";

// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import {
  collection,
  getDocs,
  getFirestore,
  orderBy,
  query,
} from "firebase/firestore";
import { FaqType } from "../Models/Auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAZy8ZLqIab-_g2OUQ_ArB6A7_euO365Ck",
  authDomain: "colendi-payments-web.firebaseapp.com",
  projectId: "colendi-payments-web",
  storageBucket: "colendi-payments-web.appspot.com",
  messagingSenderId: "460692757449",
  appId: "1:460692757449:web:784340aee4e56ed50ee618",
  measurementId: "G-FY0HB9EGME",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

// Export Firebase services
export { analytics };

// Initialize RemoteConfig
const firebaseRemoteConfig = getRemoteConfig(app);
firebaseRemoteConfig.settings = {
  minimumFetchIntervalMillis: 1, // 1 saat
  fetchTimeoutMillis: 60000, // 1 dakika
};

// Cache remote config values
var remoteValues: Record<string, any> = {};
if (localStorage.getItem("remoteConfig")) {
  remoteValues = JSON.parse(localStorage.getItem("remoteConfig") || "{}");
}

export async function fetchFaqs() {
  try {
    const faqCollection = collection(db, "faqs");
    const faqQuery = query(faqCollection, orderBy("order"));
    const faqSnapshot = await getDocs(faqQuery);
    const faqList = faqSnapshot.docs.map((doc) => doc.data() as FaqType);

    return faqList;
  } catch (error) {
    return [];
  }
}
export async function FetchRemoteConfig(): Promise<boolean> {
  try {
    await fetchAndActivate(firebaseRemoteConfig);
    const configValues = getAll(firebaseRemoteConfig);
    remoteValues = configValues;
    localStorage.setItem("remoteConfig", JSON.stringify(configValues));
    return true;
  } catch (err) {
    console.log("Failed to fetch remote config", err);
    return false;
  }
}

export function getRemoteValue(key: string): string {
  try {
    if (remoteValues[key]?._value) {
      return remoteValues[key]._value;
    } else {
      return key;
    }
  } catch (e) {
    return key;
  }
}

/**
 * Like getRemoteValue, but returns `fallback` while the key is not yet defined
 * in remote config (getRemoteValue returns the key itself in that case).
 * When `variable` is provided it replaces the "${val}" placeholder used by
 * remote-config values, and the "{val}" placeholder used by code fallbacks.
 */
export function getRemoteText(
  key: string,
  fallback: string,
  variable?: string
): string {
  const value = getRemoteValue(key);
  const text = value === key ? fallback : value;
  if (variable === undefined) return text;
  return text.replaceAll("$" + "{val}", variable).replaceAll("{val}", variable);
}

/** Boolean remote-config flag. Missing key → `defaultValue`. Only `"true"` is truthy. */
export function getRemoteBoolean(
  key: string,
  defaultValue: boolean = false
): boolean {
  const value = getRemoteValue(key);
  if (value === key) return defaultValue;
  return value === "true";
}

export function getRemoteValueVariable(key: string, variable: string): string {
  try {
    const val = getRemoteValue(key);
    return val.replaceAll("${val}", variable);
  } catch (e) {
    console.log("Cannot find key: " + key);
    return "";
  }
}
